import { useCallback, useEffect, useState } from 'react';

export type AsyncResource<T> = {
  data?: T;
  loading: boolean;
  error?: Error;
  reload: () => void;
};

export function useAsyncResource<T>(load: () => Promise<T>, dependencies: readonly unknown[], errorMessage = '데이터를 불러오지 못했습니다.'): AsyncResource<T> {
  const [data, setData] = useState<T>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error>();
  const [version, setVersion] = useState(0);
  const reload = useCallback(() => setVersion((value) => value + 1), []);

  useEffect(() => {
    let active = true;
    setData(undefined);
    setLoading(true);
    setError(undefined);
    void load().then(
      (value) => {
        if (!active) return;
        setData(value);
        setLoading(false);
      },
      (reason: unknown) => {
        if (!active) return;
        setError(reason instanceof Error ? reason : new Error(errorMessage));
        setLoading(false);
      },
    );
    return () => { active = false; };
    // 호출자가 데이터 로더의 의존성을 명시해 같은 요청의 불필요한 반복을 막는다.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...dependencies, version]);

  return { data, loading, error, reload };
}
